(function() {
    'use strict';
    /**
     * @memberof app
     *@ngdoc service
     *@name autorService
     *@description
     *Servicio de autores
     */

    angular
        .module('app')
        .factory('autorService', autorService);

    autorService.$inject = ["$http","$filter","$q","$timeout"];

    function autorService($http,$filter,$q,$timeout) {    

    	var autors = {

            cache:[]
        };


        var items = [];

        autors.getSlugify = function(n)
        {
            return $filter('slugify')(n);
        };
		/**
        * @ngdoc method
        * @name getAutorBySlug
        * @memberof autorService
        * @desciption
        * Obtiene el autor por slugs.
        */
    	autors.getAutorBySlug = function(slug)
    	{
    		
    		for (var i = 0; i < autors.data.length; i++) {
    			var nom = autors.data[i].data.nom+' '+autors.data[i].data.cognoms;
    			if($filter('slugify')(nom)==slug)
    			{
    				return autors.data[i];
    			}
    		}
    	};

        /**
        * @ngdoc method
        * @name getAutorByID
        * @memberof autorService
        * @desciption
        * Obtiene el autor por slugs.
        */
        autors.getAutorByID = function(id)
        {

            
            if(!autors.data)
                return false;

            if( autors.cache[id] !== undefined)
                return autors.data[autors.cache[id]];

            for (var i = 0; i < autors.data.length; i++) {
                if(autors.data[i].id==id)
                {
                    autors.cache[id] = i;
                    return autors.data[i];
                }
            }
            return false;
        };
    	/**
        * @ngdoc method
        * @name invisibleAll
        * @memberof autorService
        * @desciption
        * Cambia la propiedad visible a false de todos loas autores
        */
        autors.invisibleAll = function()
        {

            for (var i = 0; i < autors.data.length; i++) {
                autors.data[i].visible = false ;
            }

        };


        autors.invisibleContent = function(espais,rutas)
        {
            
            for (var i = 0; i < autors.data.length; i++) {
                autors.data[i].visible = false ;
                var id = autors.data[i].id;
            
                for (var j = 0; j < espais.length; j++) {
            
                    if(espais[j].data.autor == id){

                        autors.data[i].visible = true;
                        break;
                    }

                }

            }
            console.log("AUTOR END");
            return true;

        };

        /**
        * @ngdoc method
        * @name setVisible
        * @memberof autorService
        * @desciption
        * Cambia la propiedad visible a un autor
        */
        autors.setVisible = function(autor,v)
        {

            for (var i = 0; i < autors.data.length; i++) {
                if(autors.data[i].id == autor)
                    autors.data[i].visible = v ;
            }

        };

        autors.setVisibleMass = function(arr)
        {
            for (var i = 0; i < autors.data.length; i++) {
                if(arr.indexOf(autors.data[i].id)!==-1)
                    autors.data[i].visible = true ;
                else
                    autors.data[i].visible = false;
            }

        };

        autors.switchVisible = function(autor)
        {
            console.log("SWITCHIMNHG");
            if(autors.isVisibleAll()){
                autors.invisibleAll();
            }

            autors.setVisible(autor.id,!autor.visible);
        };


        autors.isInVisibleAll = function()
        {
            var b =  true;

            for (var i = 0; i < autors.data.length; i++) {
                
                if(autors.data[i].visible)
                    b = false;
            }
            return b;
        };

        autors.isVisibleAll = function()
        {
            var b =  true;

            for (var i = 0; i < autors.data.length; i++) {
                
                if(!autors.data[i].visible)
                    b = false;
            }
            return b;
        };

        /**
        * @ngdoc method
        * @name visibleAll
        * @memberof autorService
        * @desciption
        * Cambia la propiedad visible a true de todos loas autores
        */
        autors.visibleAll = function()
        {

            for (var i = 0; i < autors.data.length; i++) {
                
                autors.data[i].visible = true ;
            }

        };
        /**
        * @ngdoc method
        * @name openInMenu
        * @memberof autorService
        * @desciption
        * Abre en el menu.
        */

        autors.openInMenu = function(id,item,slug,close)
        {
            if(!close)
                autors.closeAllInMenu();
            
            var autor = autors.getAutorByID(id);
            
            autor.menu[item] = true;
            if(slug)
                autor.menu[slug] = true;

            console.log(autor.menu);
            console.log(slug);
        };

        /**
        * @ngdoc method
        * @name closeInMenu
        * @memberof autorService
        * @desciption
        * Cierra en el menu.
        */
        autors.closeInMenu = function(id,item,slug)
        {
            var autor = autors.getAutorByID(id);
            autor.menu[item] = false;
            if(slug)
                autor.menu[slug] = false;
        };

        /**
        * @ngdoc method
        * @name toogleInMenu
        * @memberof autorService
        * @desciption
        * switch en el menu.
        */
        autors.toogleInMenu = function(id,item)
        {
            var autor = autors.getAutorByID(id);
            autor.menu[item] = !autor.menu[item];
        };

        /**
        * @ngdoc method
        * @name toogleInMenu
        * @memberof autorService
        * @desciption
        * switch en el menu.
        */
        autors.closeAllInMenu = function()
        {
            for (var i = 0; i < autors.data.length; i++) {
                angular.forEach(autors.data[i].menu, function(value, key) {
                    autors.data[i].menu[key] = false;
                });    
            }
        };


        /**
        * @ngdoc method
        * @name addSlugs
        * @memberof autorService
        * @desciption
        * Crea los slugs de cada uno de los autores.
        */
        autors.addSlugs = function()
        {

            for (var i = 0; i < autors.data.length; i++) {
                var nom = autors.data[i].data.nom+' '+autors.data[i].data.cognoms;
                autors.data[i].data.slug = $filter('slugify')(nom);
                autors.data[i].data.cognom_slug = $filter('slugify')(autors.data[i].data.cognoms);
                autors.data[i].visible = true ;
                autors.data[i].menu = {espais:false,rutes:false,centre:false} ;
            }

        };
    	/**
        * @ngdoc method
        * @name getAutors
        * @memberof autorService
        * @desciption
        * Obtienes los autores con cache.
        */
        autors.load = false;
    	autors.getAutors = function (){
            
            var deferred = $q.defer();
            
            

            if(autors.data){
                $timeout(function(){
                    deferred.resolve(autors.data);
                },20);
            }else{
                autors.load = true;
                var url= '/api/v1/autors';
                $http({
                    method  : 'GET',
                    url     : url,
                
                }).then(Success)
                  .catch(Failed);
            }
            
            function Success(data){
                autors.load = true;  
            	autors.data = data.data;
                autors.addSlugs();
                deferred.resolve(autors.data);
            }

            function Failed(data){
                console.log(data);
                deferred.reject(false);
            }

            return deferred.promise;

        };


    	return autors;
    }



})();
